import { MachinesApiService } from '@api/machines'
import { handleCatchError } from '@common/utils'
import { useQuery } from '@tanstack/react-query'

export const EQUIPMENT_QUERY_KEYS = {
  GET_EQUIPMENT_CACHE: 'getEquipmentCache',
  GET_BRAND_WARRANTY_PRICES: 'getBrandWarrantyPrices'
}

type BaseQuoteData = {
  quoteId?: string
  equipmentId?: string | null
}

export const useGetBrandWarrantyPrices = ({
  equipmentId,
  quoteId,
  useBrandWarranty: _useBrandWarranty
}: BaseQuoteData & {
  useBrandWarranty: boolean
}) => {
  return useQuery({
    queryKey: [
      EQUIPMENT_QUERY_KEYS.GET_BRAND_WARRANTY_PRICES,
      quoteId,
      equipmentId
    ],
    queryFn: async () => {
      try {
        if (quoteId && equipmentId) {
          return await MachinesApiService.quotationItemBrandWarrantyPrices(
            quoteId,
            equipmentId
          )
        }
      } catch (error) {
        handleCatchError(error)
      }
    },
    // enabled: useBrandWarranty,
    refetchOnMount: 'always'
  })
}
